/** お知らせ(suite 共通)の問い合わせ。画面部品は notifications.tsx にある。
 *
 * 種別の日本語は core が持つ(kind_label をそのまま出す。画面は対応表を持たない)。
 */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useApi } from "../lib/useApi";

export const NOTIFICATION_POLL_MS = 60_000;

/** 一覧。画面を移ったときと60秒ごとに取り直す(未読の数をヘッダーに出すため)。 */
export function useNotifications(limit = 20) {
  const api = useApi();
  const location = useLocation();
  const query = useQuery({
    queryKey: ["notifications", limit],
    queryFn: () => api.notifications(new URLSearchParams({ limit: String(limit) })),
    refetchInterval: NOTIFICATION_POLL_MS,
    staleTime: 10_000,
  });
  const { refetch } = query;
  useEffect(() => {
    void refetch();
  }, [location.pathname, refetch]);
  return query;
}

export function useMarkRead() {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.readNotification(id),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ["notifications"] }),
    onError: (e: unknown) => void message.error(e instanceof Error ? e.message : String(e)),
  });
}

/** 既読を 1 件消す */
export function useDeleteNotification() {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.deleteNotification(id),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ["notifications"] }),
    onError: (e: unknown) => void message.error(e instanceof Error ? e.message : String(e)),
  });
}

/** 既読をまとめて消す(未読は残る) */
export function useDeleteReadNotifications() {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.deleteReadNotifications(),
    onSuccess: (r) => {
      void message.success(r.deleted > 0 ? `既読のお知らせ ${r.deleted} 件を消した` : "既読のお知らせは無い");
      void qc.invalidateQueries({ queryKey: ["notifications"] });
    },
    onError: (e: unknown) => void message.error(e instanceof Error ? e.message : String(e)),
  });
}
